export default __webpack_public_path__ + "b84d76a6cf005e6597b9e1318512507f.jpg";